import { Injectable } from "@angular/core";
import { ApplicationOfferBundleData } from "../../../application/application.model";
import { DisplayAllOffersData } from "../../models/display-all-offers-data.model";
import { getBestOfferBundles, getMaxOfferValue } from "../../models/offer-bundle-grouping";
import { OfferActionsInternalService } from "../../services/actions/offer-actions.internal.service";

@Injectable()
export class OfferSummaryFacade {
  constructor(private actionsService: OfferActionsInternalService) {}

  getBestOfferBundles(
    offerBundles: ApplicationOfferBundleData[]
  ): ApplicationOfferBundleData[] {
    return getBestOfferBundles(offerBundles);
  }

  getMaxOfferAmount(offerBundles: ApplicationOfferBundleData[]): number {
    return getMaxOfferValue(offerBundles, (x) => x.amount);
  }

  getMaxRepayment(offerBundles: ApplicationOfferBundleData[]): number {
    return getMaxOfferValue(offerBundles, (x) => x.repaymentTerm);
  }

  linkBank(entityId: number): void {
    this.actionsService.linkBank(entityId);
  }

  displayAllOffers(data: DisplayAllOffersData): void {
    this.actionsService.displayAllOffers(data);
  }
}
